module.exports = __webpack_public_path__ + "static/img/5.8e87cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/crm/5.png
// module id = 58qw
// module chunks = 0